import * as React from "react";
// Remember that all const are suffix _svg

const facebook_svg = (
  <svg className={"icon_svg facebook_svg"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.5 25">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M8.526 25V13.75h3.416l.558-5H8.526V6.313c0-1.287.034-2.562 1.832-2.562h1.823V.176A20.759 20.759 0 0 0 9.032.001c-3.308 0-5.379 2.075-5.379 5.875v2.875H0v5h3.654V25Z"
      data-name="facebook-[#176]"
    />
  </svg>
);

const twitter_svg = (
  <svg className={"icon_svg twitter_svg"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.909 18.326">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M7.2 18.326A13.176 13.176 0 0 0 20.573 5.165c0-.206 0-.4-.014-.607a9.456 9.456 0 0 0 2.345-2.394 9.565 9.565 0 0 1-2.7.732A4.676 4.676 0 0 0 22.27.331a9.3 9.3 0 0 1-2.985 1.122 4.764 4.764 0 0 0-6.651-.194 4.586 4.586 0 0 0-1.36 4.422A13.467 13.467 0 0 1 1.587.847a4.587 4.587 0 0 0 1.456 6.174 4.782 4.782 0 0 1-2.134-.573v.058a4.66 4.66 0 0 0 3.771 4.536 4.745 4.745 0 0 1-2.121.069 4.69 4.69 0 0 0 4.391 3.218 9.427 9.427 0 0 1-5.837 1.982c-.373 0-.747-.022-1.119-.058a13.547 13.547 0 0 0 7.2 2.073"
      data-name="twitter-[#154]"
    />
  </svg>
);

const instagram_svg = (
  <svg className={"icon_svg instagram_svg"} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 19.996">
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M5.87.119a5.518 5.518 0 0 0-5.788 5.78c-.046 1-.314 8.6.462 10.59a5.034 5.034 0 0 0 2.911 2.9 7 7 0 0 0 2.415.46c8.86.4 12.145.19 13.53-3.36a7.217 7.217 0 0 0 .462-2.41c.4-8.88-.066-10.81-1.61-12.35C17.027.509 15.586-.321 5.87.119m.081 17.95a5.87 5.87 0 0 1-1.848-.34 3.28 3.28 0 0 1-1.888-1.89c-.591-1.51-.395-8.7-.342-9.86a4.263 4.263 0 0 1 1.086-2.99c.995-.99 2.281-1.48 11.034-1.08a4.266 4.266 0 0 1 2.992 1.08c1 .99 1.489 2.29 1.087 11.01a5.445 5.445 0 0 1-.342 1.84c-.9 2.31-2.973 2.63-11.779 2.23m8.139-13.38a1.195 1.195 0 1 0 1.194-1.19 1.19 1.19 0 0 0-1.194 1.19m-9.227 5.3a5.11 5.11 0 1 0 5.109-5.1 5.1 5.1 0 0 0-5.109 5.1m1.793 0a3.317 3.317 0 1 1 3.316 3.31 3.311 3.311 0 0 1-3.316-3.31"
      data-name="instagram-[#167]"
    />
  </svg>
);

const linkedin_svg = (
  <svg className="icon_svg linkedin_svg" viewBox="0 0 20.807 20.807">
    <path
      fill="#fff"
      d="M4.658 20.807H.344V6.916h4.314ZM2.5 5.021A2.51 2.51 0 1 1 5 2.5a2.519 2.519 0 0 1-2.5 2.521Zm18.3 15.786h-4.3v-6.762c0-1.612-.033-3.678-2.243-3.678-2.243 0-2.587 1.751-2.587 3.562v6.878H7.357V6.916H11.5v1.895h.06a4.534 4.534 0 0 1 4.082-2.243c4.366 0 5.169 2.875 5.169 6.609v7.631Z"
      data-name="Path 15"
    />
  </svg>
);
export { facebook_svg, instagram_svg, linkedin_svg, twitter_svg };
